import { Component } from '@angular/core';

@Component({
  selector: 'app-system-monitoring',
  standalone: true,
  imports: [],
  template: ``,
  styles: ``,
})
export class SystemMonitoringComponent {}
